<template lang="pug">
div
  #content.snap-content
    .content-center(v-if="error")
      .icon-dialog.text-center.mt-5(style='color:#ffc902')
        i.fas.fa-tools
      .head-notice.text-center.text-white
        i.fas.fa-exclamation-triangle.mr-1
        span {{ error }}
      .w-100.mx-auto.px-2.text-center.text-white
        //- p.font-italic.mb-5 Dear valued customers, our system currently under maintenance.
        //- p Estimate maintenance time:
        //- p.font-weight-bold.mb-5
        //-   | From : Wednesday, 24 July, 2019 1:30:00 PM
        //-   br
        //-   | To : Wednesday, 24 July, 2019 3:30:00 PM
        //- p.mt-5.mb-1 Sorry for the inconvenience caused.
    .content-center(v-else)
      .loader

</template>

<script>
import config from "@/config";
import xhr from "@/library/_xhr-game.js";
import mixinTypes from "@/library/mixinTypes";

export default {
  data() {
    return {
      url: "",
      error: ""
    };
  },
  created() {
    this.launchGame();
  },
  methods: {
    launchGame() {
      var q = this.$route.query;

      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: true
      };

      xhr.launchMiniGame(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 200);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    }
  }
};
</script>